import type { BootstrapPayload, HttpPort, IBootstrapService, PresentationConfig } from "../contracts";
import { mapBootstrap } from "./mappers";

export class BootstrapService implements IBootstrapService {
    constructor(private readonly http: HttpPort) {}

    async bootstrap(): Promise<BootstrapPayload> {
        return mapBootstrap(await this.http.get("/api/web/bootstrap"));
    }

    async presentation(): Promise<PresentationConfig> {
        const raw = await this.http.get<Partial<PresentationConfig>>("/api/web/presentation");
        return {
            title: typeof raw?.title === "string" && raw.title.trim() ? raw.title : "EDE Workspace",
            favicon_url: typeof raw?.favicon_url === "string" && raw.favicon_url ? raw.favicon_url : "/favicon",
        };
    }
}
